import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { isEmpty } from 'lodash';
import ClaimJobItem from 'models/claims/claimJobItem/Model.ClaimJobItem';
import { CountryCode, CountryCodeFallback } from 'models/enums/CountryCode';
import Currency from 'models/enums/Currency';
import LineItem from 'models/enums/LineItem';
import PaymentStatus from 'models/enums/PaymentStatus';
import Insurer from 'models/productManagement/insurer/Model.Insurer';
import { ClaimEditJobPayeeItemProvider, ClaimJobTableProps } from '../../ClaimEdit.Job.Hooks';
import ClaimEditJobItem, { addJobItemRowButtonStyles } from '../ClaimEdit.Job.Item';

const ClaimEditJobOtherTable = ({
  items,
  lossCodes,
  isWarrantyProduct,
  isAddDisabled,
  currency,
  product,
  insurerHeaders,
  updateJobItem,
  removeJobItem,
}: ClaimJobTableProps) => {
  const { lang } = getLocales();
  const countryCode =
    currency === Currency.USD ? CountryCode.USA : currency === Currency.CAD ? CountryCode.CAN : CountryCodeFallback.CA;

  return (
    <>
      <h4>{lang.otherSublet}</h4>
      <table className={ThemeTableSimple} style={{ fontSize: Theme.FontSize.S }}>
        <thead>
          <tr>
            <th style={{ paddingLeft: '25px' }}>#</th>
            <th style={{ textAlign: 'center' }}>{lang.payee}</th>
            <th style={{ textAlign: 'center' }}>{lang.lossCode}</th>
            <th style={{ textAlign: 'center' }}>{lang.status}</th>
            <th style={{ textAlign: 'center' }}>{lang.requestedAmt}</th>
            <th style={{ textAlign: 'center' }}>{lang.adjustedAmt}</th>
            {!isEmpty(insurerHeaders) &&
              insurerHeaders.map((header) => (
                <th key={header} style={{ textAlign: 'center' }}>
                  {header}
                </th>
              ))}
            <th style={{ textAlign: 'center' }}>
              {countryCode === CountryCode.CAN || countryCode === CountryCodeFallback.CA ? lang.gstHst : lang.tax}
            </th>
            {(countryCode === CountryCode.CAN || countryCode === CountryCodeFallback.CA) && (
              <th style={{ textAlign: 'center' }}>{lang.pst}</th>
            )}
            <th style={{ textAlign: 'center' }}>{lang.total}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ClaimEditJobPayeeItemProvider countryCode={countryCode}>
            <DataMap
              data={items}
              render={({ data: { item, index }, index: ordinalNumber }) => (
                <ClaimEditJobItem
                  key={index}
                  index={index}
                  ordinalNumber={ordinalNumber}
                  data={{ ...item, isWarrantyProduct }}
                  insurerHeaders={insurerHeaders}
                  lossCodes={lossCodes}
                  onDelete={(data) => removeJobItem(data, index)}
                  onUpdate={(data) => updateJobItem({ ...item, ...data }, index)}
                  countryCode={countryCode}
                />
              )}
            />
          </ClaimEditJobPayeeItemProvider>
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={12 + (insurerHeaders.length ?? 0)}>
              <Button
                class={ThemeButtonCircle}
                style={addJobItemRowButtonStyles}
                media="fas-plus"
                onClick={() =>
                  updateJobItem(
                    new ClaimJobItem({
                      jobItemTypeCode: LineItem.other,
                      statusCode: PaymentStatus.unpaid,
                      currency,
                      insurerAdjudications: Insurer.createInsurerAdjudications(
                        product?.insurers?.map((it) => new Insurer(it)),
                        currency
                      ),
                      adjudication: 0.0,
                      correction: 0.0,
                      claimJobItemPayee: {
                        payee: { countryCode },
                      } as Model.IClaimJobItemPayee,
                    }).toJSON()
                  )
                }
                disabled={isAddDisabled}
                render={lang.otherSublet}
                htmlElementProps={{
                  title: 'Add new other item',
                }}
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default ClaimEditJobOtherTable;
